import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionModalSwapLast } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionBuildingsShowBouncingArrow, TypeActionBuildings, } from "../actionBuildings";
export var epicBuildingsStartUpgrade = function (action$) {
    return action$.pipe(ofType(TypeActionBuildings.StartUpgrade), switchMap(function (action) {
        return from([
            actionModalSwapLast(IdModal.BuildingUpgrade),
            actionBuildingsShowBouncingArrow(action.building, false),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsStartUpgrade.ts
// module id = 2089
// module chunks = 3